import { ErrorHandler, Injectable } from '@angular/core';
import {MetricsService} from '../services/metrics.service';
import {CustomMetricsName} from '../components/models/metrics/custom-metrics-name.enum';
import {MetricsType} from '../components/models/metrics/metrics-type.enum';
import * as md5 from 'md5';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {

    private errorMetricsEnabled: boolean = true;
    private previousErrorMd5: string;

    constructor(private metricsService: MetricsService) {
        super();
    }

    handleError(error: any): void {
        super.handleError(error);
        if (this.errorMetricsEnabled) {
            const metricsBody = {
                name: error ? error.name : null,
                message: error ? error.message : null,
                stack: error ? error.stack : null
            };
            const currentErrorMd5 = md5(JSON.stringify(metricsBody));
            if (this.previousErrorMd5 !== currentErrorMd5) { // prevent sending multiple metrics for same error emitted in short time
                this.metricsService.sendSimpleMetric(CustomMetricsName.GLOBAL_ERROR, MetricsType.ERROR, JSON.stringify(metricsBody));
            }
            this.previousErrorMd5 = md5(JSON.stringify(metricsBody));
        }
    }
}
